import React, { useState } from "react";
import moment from "moment";
import { Input, Popover, Button } from "antd";
import {
  CalendarOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";

const YearPicker = ({ value, onChange, placeholder = "Select year" }) => {
  const [open, setOpen] = useState(false);
  const [panelYear, setPanelYear] = useState(moment().year());

  const startYear = Math.floor(panelYear / 12) * 12;

  const years = Array.from({ length: 12 }, (_, i) => startYear + i);

  const handleYearClick = (year) => {
    setOpen(false);
    if (onChange) onChange(year);
  };

  const yearGrid = (
    <div className="w-[250px]">
      <div className="flex justify-between items-center mb-2 px-2">
        <Button
          type="text"
          icon={<LeftOutlined />}
          onClick={() => setPanelYear(panelYear - 12)}
        />
        <span className="font-medium">
          {startYear} - {startYear + 11}
        </span>
        <Button
          type="text"
          icon={<RightOutlined />}
          onClick={() => setPanelYear(panelYear + 12)}
        />
      </div>
      <div className="grid grid-cols-3 gap-2 p-2">
        {years.map((year) => {
          const isDisabled = year > moment().year();

          return (
            <Button
              key={year}
              type={year === value ? "primary" : "text"}
              onClick={() => !isDisabled && handleYearClick(year)}
              className="w-full"
              disabled={isDisabled}
            >
              {year}
            </Button>
          );
        })}
      </div>
    </div>
  );

  return (
    <Popover
      content={yearGrid}
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      className="w-[120px]"
    >
      <Input
        readOnly
        value={value || ""}
        placeholder={placeholder}
        onClick={() => setOpen(true)}
        suffix={<CalendarOutlined style={{ color: "#808080" }} />}
      />
    </Popover>
  );
};

export default YearPicker;
